export default __webpack_public_path__ + "static/media/comingsoon.1a0e4b20.png";